
// import * as MUTATION from '../mutationTypes'
const state = {

}

const mutations = {

}

export const actions = {

}

export const getters = {

}

export default {
    state,
    mutations,
}
